import { useNavigate } from 'react-router-dom'
import styles from '../../styles/admin/CenterCard.module.scss'
import SaveButton from '../common/SaveButton'
import { useAuthStore } from '../../store'

interface CenterCardProps {
  CENTER_ID: number
  NAME: string
  MANAGER_NAME: string
  MANAGER_EMAIL: string
  ADDRESS: string
  PHONE: string
  REG_DTM: string
  onDetailClick: (centerData: any) => void
}

const CenterCard = ({
  CENTER_ID,
  NAME,
  MANAGER_NAME,
  MANAGER_EMAIL,
  ADDRESS,
  PHONE,
  REG_DTM,
  onDetailClick,
}: CenterCardProps) => {
  const navigate = useNavigate()
  const { viewManagerPage } = useAuthStore()

  const handleAccountSwitch = () => {
    const centerData = {
      CENTER_ID,
      NAME,
      MANAGER_NAME,
      MANAGER_EMAIL,
      ADDRESS,
      PHONE,
      REG_DTM,
    }
    viewManagerPage(centerData)

    // @ts-ignore
    useAuthStore.setState((prev) => ({
      user: {
        ...prev.user,
        CENTER_ID: String(centerData?.CENTER_ID),
      },
    }))

    navigate('/dashboard/manager')
  }

  const handleDetailClick = () => {
    onDetailClick({
      CENTER_ID,
      NAME,
      MANAGER_NAME,
      MANAGER_EMAIL,
      ADDRESS,
      PHONE,
      REG_DTM,
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.centerCardWrapper}>
        <h3 className={styles.centerName}>{NAME}</h3>
        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <strong>Manager:</strong> {MANAGER_NAME}
          </div>
          <div className={styles.infoItem}>
            <strong>Email:</strong> {MANAGER_EMAIL}
          </div>
          <div className={styles.infoItem}>
            <strong>Address:</strong> {ADDRESS}
          </div>
          <div className={styles.infoItem}>
            <strong>Phone Number:</strong> {PHONE}
          </div>
          <div className={styles.infoItem}>
            <strong>Date Registered:</strong> {REG_DTM}
          </div>
        </div>
        <div className={styles.buttonGroup}>
          <SaveButton onClick={handleAccountSwitch}>Manage</SaveButton>
          <SaveButton onClick={handleDetailClick}>View Details</SaveButton>
        </div>
      </div>
    </div>
  )
}

export default CenterCard
